import { tokenize } from 'app/functions/string';

/**
 * Given some options and a search string, this function will return
 * the filtered and sorted options.
 *
 * @todo Write tests
 */
export const filterLocationOptions = (options, userInput) => {
    // nothing to filter/sort on
    if (!userInput) {
        return options.sort((a, b) => {
            if ((a.group && b.group) && a.group.key !== b.group.key) {
                return a.group.order;
            }

            // sort by "tokenizedLabel" ascending
            return a.tokenizedLabel.localeCompare(b.tokenizedLabel);
        });
    }

    const sanitizedInput = tokenize(userInput);
    const filteredResults = [];

    for (let i = 0; i < options.length; i += 1) {
        const currentItem = options[i];

        if (currentItem.tokenizedAliases.indexOf(sanitizedInput) >= 0) {
            filteredResults.push(currentItem);
        }
    }

    return filteredResults.sort((a, b) => {
        // if user is searching, items that START with the userInput should appear on top
        const aStartsWithUserInput = a.tokenizedLabel.startsWith(sanitizedInput);
        const bStartsWithUserInput = b.tokenizedLabel.startsWith(sanitizedInput);

        if ((a.group && b.group) && a.group.key !== b.group.key) {
            return a.group.order;
        }

        // items that start with the input always appear on top
        if (aStartsWithUserInput && !bStartsWithUserInput) {
            return -1;
        } else if (bStartsWithUserInput && !aStartsWithUserInput) {
            return 1;
        }

        // sort by "tokenizedLabel" ascending
        return a.tokenizedLabel.localeCompare(b.tokenizedLabel);
    });
};
